<template>
  <div>


<h2 class="goth">Verb som styr dativ</h2>

<div class="grammatikparagrafbredd leftorient">
<p>Det finns vissa verb på tyska som ”styr dativ”.
    D.v.s. trots att de bara har ett objekt kopplat till sig står det i dativ och inte i ackusativ
    (som man kanske annars förväntat sig enligt den vanliga satsanalysen).</p>

<p>Några vanliga verb i denna kategori återfinns i tabellen nedan</p>


<table class="">

    <tr>
        <td class="ljusgra">
            <b>danken</b>
        </td>
        <td class="ljusgra">
            tacka
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <b>fehlen</b>
        </td>
        <td class="ljusgra">
            saknas, fattas
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <b>folgen</b>
        </td>
        <td class="ljusgra">
            följa
        </td>
    </tr>



    <tr>
        <td class="ljusgra">
            <b>gefallen</b>
        </td>
        <td class="ljusgra">
            tilltala, behaga<br>
            <div class="mindre">(svenskan använder ofta annan konstruktion med verbet "gilla")</div>
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <b>gehören</b>
        </td>
        <td class="ljusgra">
            tillhöra
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <b>gelingen</b>
        </td>
        <td class="ljusgra">
            lyckas
        </td>
    </tr>

    <tr>
        <td class="ljusgra">
            <b>geschehen, passieren</b>
        </td>
        <td class="ljusgra">
            hända
        </td>
    </tr>
    <tr>
        <td class="ljusgra">
            <b>glauben</b>
        </td>
        <td class="ljusgra">
            tro
        </td>
    </tr>
    <tr>
        <td class="ljusgra">
            <b>gratulieren</b>
        </td>
        <td class="ljusgra">
            gratulera
        </td>
    </tr>
    <tr>
        <td class="ljusgra">
            <b>helfen</b>
        </td>
        <td class="ljusgra">
            hjälpa
        </td>
    </tr>
    <tr>
        <td class="ljusgra">
            <b>passen</b>
        </td>
        <td class="ljusgra">
            passa
        </td>
    </tr>

</table>

<p></p>

<p>Vissa av dessa fungerar precis som verben i svenskan, man måste bara tänka på att objektet på tyska bli i dativ: </p>

<div class="ruta">

<p><i>
Ich <b>danke Ihnen</b>, Frau Meier!
<br>
Jag tackar Er, fru Meier!
</i></p>


<p><i>
Ich <b>glaube dir</b> nicht!
<br>
Jag tror dig inte!
</i></p>

<p><i>
Kannst du <b>mir</b> bitte <b>helfen</b>!
<br>
Kan du hjälpa mig, är du snäll!
</i></p>
</div>
<br>
<p>Några av dessa verb används dock litet annorlunda än motsvarande vanligaste konstruktion i svenskan:</p>


<div class="ruta">

<div class="quasi-p"><i>
Das Haus <b>gefällt mir</b> wirklich.</i>
<br>
<div class="mindre"> <i>Huset tilltalar mig verkligen</i></div><i> Jag gillar verkligen huset.
</i></div>

<p><i>
Es ist <b>mir</b> endlich <b>gelungen</b>!
<br>
Jag har äntligen lyckats!
</i></p>

<div class="quasi-p"><i>
<b>Fehlt dir</b> was?</i>


<div class="mindre"> <i>Fattas dig något?</i></div><i> Saknar du något?
</i></div>
</div>
<br><br>
<p class="mindre">Från kemin har språkvetenskapen lånat begreppet <i>valens</i>.
    Precis som olika atomkärnor har olika antal valenselektroner kopplade till sig,
    så har olika verb olika valens - olika typer av objekt och andra ord kopplade till sig enligt vissa regler.
    Verben som "styr dativ" har helt enkelt subjekt och dativobjekt, men inte ackusativobjekt i sin valens.
</p>
<br><br><br>

</div>


</div>



</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},

metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "verb som styr dativ"
            }
        ]
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
